export const AccountTypes = {
  Partner: "Partner",
  Provider: "Provider",
  Seeker: "Seeker",
  Admin: "Admin",
  Corporate: "Corporate",
  Startup: "Start Up"
};